import * as MathLive from "mathlive"

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(MathLive)
})
